var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"graphic-details"},[(_vm.productDetails)?_c('div',{staticClass:"graphic-info",staticStyle:{"width":"100%"},domProps:{"innerHTML":_vm._s(_vm.productMsg.content)}}):_c('div',{staticClass:"no-msg"},[_c('img',{attrs:{"src":require("../image/Sj.png"),"alt":""}}),_c('p',[_vm._v("该商品暂无详情")])])]),_c('ToBack')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }